import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading0, Image } from '@cian/ui-kit';
import { SpecialFskIntroduction, DefaultIntroduction } from '../../components/Introduction';
import { checkFsk, getDeveloper } from '../../selectors';
import { NewBuildingFacts } from '../NewBuildingFacts';
import { ContactButtonsContainer } from '../ContactButtons';
import { Contacts } from '../Contacts';

export function Introduction() {
  const {
    name,
    poster,
    logoUrl,
    buildingStatistics: { newBuildingsInProcess, housesInProcess, readyNewBuildings, readyHouses },
    yearOfFoundation,
  } = useSelector(getDeveloper);
  const isFsk = useSelector(checkFsk);
  const hasPoster = Boolean(poster);
  const title = (
    <ArticleHeading0 as="h1" color={hasPoster ? 'white_100' : 'black_100'}>
      Застройщик
      <br />
      {name}
    </ArticleHeading0>
  );
  const backgroundImage = poster ? <Image src={poster} objectFit="cover" width="100%" height="100%" /> : null;
  const logo = logoUrl ? <Image src={logoUrl} width="100px" height="100px" objectFit="contain" /> : null;

  return isFsk ? (
    <SpecialFskIntroduction
      title={title}
      backgroundImage={backgroundImage}
      logo={logo}
      contacts={<Contacts />}
      facts={
        <NewBuildingFacts
          hasPoster={hasPoster}
          newBuildingsInProcess={newBuildingsInProcess}
          housesInProcess={housesInProcess}
          readyNewBuildings={readyNewBuildings}
          readyHouses={readyHouses}
          foundationYear={yearOfFoundation}
          direction="horizontal"
          variant="fsk"
        />
      }
    />
  ) : (
    <DefaultIntroduction
      title={title}
      hasPoster={hasPoster}
      backgroundImage={backgroundImage}
      logo={logo}
      contacts={<ContactButtonsContainer hasPoster={hasPoster} />}
      facts={
        <NewBuildingFacts
          hasPoster={hasPoster}
          newBuildingsInProcess={newBuildingsInProcess}
          housesInProcess={housesInProcess}
          readyNewBuildings={readyNewBuildings}
          readyHouses={readyHouses}
          foundationYear={yearOfFoundation}
        />
      }
    />
  );
}
